import { ScrollHorizontalComponent } from './scroll-horizontal.component';

export default angular
  .module('sfMobile.components.scroll-horizontal', [])
  .component('sfScrollHorizontal', ScrollHorizontalComponent).name;
